import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import TabView, { Tab } from '../../components/TabView';
import AdminUsersTab from './Users/AdminUsersTab';
import AdminRolesTab from './Roles/AdminRolesTab';
import AdminOrganizationsTab from './Organizations/AdminOrganizationsTab';
import AdminOrgGroupsTab from './OrgGroups/AdminOrgGroupsTab';
import Strings from '../../Strings';
import { getActiveTabNameFromUrl } from '../../utils';
import Organization from '../Organizations/Organization';
import OrganizationGroups from '../Organizations/OrganizationGroups/OrganizationGroups';
import OrgTemplates from '../Organizations/OrgTemplates';
import { isSuperUser } from '../../utils/userRoles';
import { hasAnyPermissionInGroup, hasPermission, PERMISSION_GROUPS, PERMISSIONS } from '../../utils/userPermissions';
import FeaturesConfig from './Config/FeaturesConfig';

export const root = 'admin';

export const AdminTabs = {
  Users: { key: 'users', name: Strings.users, path: `/${root}/users` },
  Roles: { key: 'roles', name: Strings.roles, path: `/${root}/roles` },
  Organizations: { key: 'organizations', name: Strings.organizations, path: `/${root}/organizations` },
  Templates: { key: 'templates', name: Strings.templates, path: `/${root}/templates` },
  OrgGroups: { key: 'org-groups', name: Strings.orgGroups || 'Org Groups', path: `/${root}/org-groups` },
  FeaturesConfig: { key: 'features-config', name: Strings.config || 'Config', path: `/${root}/config/work-types` },
};

function Admin(props) {
  const activeTab = props.match.params.tab;
  
  const tabArray = [];
  if (hasPermission(PERMISSIONS.ORGANIZATION_ADMIN) || isSuperUser()) {
    tabArray.push(
      <Tab name={AdminTabs.Users.name} path={AdminTabs.Users.path} key={AdminTabs.Users.key}>
        <AdminUsersTab />
      </Tab>
    );
  }
  if (isSuperUser()) {
    tabArray.push(
      <Tab name={AdminTabs.Roles.name} path={AdminTabs.Roles.path} key={AdminTabs.Roles.key}>
        <AdminRolesTab />
      </Tab>
    );
  }
  if (hasAnyPermissionInGroup(PERMISSION_GROUPS.ORGANIZATION)) {
    tabArray.push(
      <Tab name={AdminTabs.Organizations.name} path={AdminTabs.Organizations.path} key={AdminTabs.Organizations.key}>
        <Organization />
      </Tab>,
    );
  }
  if (hasPermission(PERMISSIONS.ORGANIZATION_MANAGEMENT) || isSuperUser()) {
    tabArray.push(
      <Tab name={AdminTabs.Templates.name} path={AdminTabs.Templates.path} key={AdminTabs.Templates.key}>
        <OrgTemplates />
      </Tab>
    );
  }
  if (hasPermission(PERMISSIONS.ORGANIZATION_GROUPING)) {
    tabArray.push(
      <Tab name={AdminTabs.OrgGroups.name} path={AdminTabs.OrgGroups.path} key={AdminTabs.OrgGroups.key}>
        <OrganizationGroups />
      </Tab>
    );
  }
  if (isSuperUser()) {
    tabArray.push(
      <Tab name={AdminTabs.FeaturesConfig.name} path={AdminTabs.FeaturesConfig.path} key={AdminTabs.FeaturesConfig.key}>
        <FeaturesConfig />
      </Tab>
    );
  }

  return (
    <TabView
      key="tabs"
      activeTab={getActiveTabNameFromUrl(
        activeTab,
        tabArray.map(t => ({ urlId: t.key, DisplayName: t.props.name })),
      )}
      routeMode
    >
      {tabArray}
    </TabView>
  );
}

const mapDispatchToProps = dispatch => ({ navigate: path => dispatch(push(path)) });

export default connect(null, mapDispatchToProps)(Admin);
